import React from 'react';
import style from './newCombo.module.scss';
import { CustomButton } from '../utils/Utils';
import { PlusCircleOutlined, CheckOutlined } from '@ant-design/icons';

export const ProductsTable = ({ productsList, orders, setOrders, isLoading }) => {
  const {
    tableContainer,
    table,
    tableHeader,
    itemHeader,
    tableBody,
    itemBody,
  } = style;
  
  const addProduct = (product) => {
    const newOrder = {
      products: [{ product: product._id, quantity: 1, minDiscount: product.minDiscount }],
      product: product._id,
      name: product.description,
      quantity: 1,
      total: product.pharmacyPrice * (1-product?.minDiscount),
      isSingleProduct: true,
    };
    setOrders([...orders, newOrder]);
  };

  const handleAddProduct = (product) => { 
    addProduct(product);
  };

  return (
    <div className={tableContainer}>
      {
        !isLoading && 
        <table className={table}>
          <thead>
            <tr className={tableHeader}>
              <th></th>
              <th className={itemHeader}>Descripcion</th>
              <th className={itemHeader}>Pcio. Fcia. C/IVA</th>
              <th className={itemHeader}>Descuento</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {productsList &&
              productsList.map((product) => {
                return (
                  <tr key={product._id} className={tableBody}>
                    <td className={itemBody}></td>
                    <td className={itemBody}>{product.description}</td>
                    <td className={itemBody}>${product.pharmacyPrice}</td>
                    <td className={itemBody}>{product.minDiscount * 100}%</td>
                    <td className={itemBody}>
                      {
                        orders.some((order) => order.product === product._id) ? (
                          <CustomButton color="btnSecondary" style={{ paddingRight: '1.8rem' }}>
                            Agregado
                            <CheckOutlined style={{marginLeft: '.75rem', fontSize: '15px'}}/>
                          </CustomButton>
                        ) : (
                          <CustomButton
                            color="btnPrimary"
                            style={{ paddingRight: '1.8rem'}}
                            onclick={() => handleAddProduct(product)}
                          >
                            Agregar
                            <PlusCircleOutlined style={{marginLeft: '.75rem', fontSize: '15px'}}/>
                          </CustomButton>
                        )
                      }
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      }
    </div>
  );
};
